export const NAVBAR_OPTONS = [
  { title: "CV", link: "CV" },
  // { title: "Tech Stack", link: "#Skills" },
  { title: "Projects", link: "#Projects" },
  { title: "Experience", link: "#Experience" },
  { title: "Feedback", link: "#Feedback" },
];
